import { Modal } from "@mui/material";
import React, { FC } from "react";
import type { ModalProps } from "@mui/material";
import cn from "classnames";
import styles from "./ImageShowModal.module.scss";
import NiceModal, { antdModalV5, useModal } from "@ebay/nice-modal-react";

type Props = Omit<ModalProps, "open" | "onClose"> & {
  className?: string;
  src: string | undefined;
};

const ImageShowModal: FC<Props> = ({ className, src, ...props }) => {
  const modal = useModal();

  const handleClose = () => {
    modal.hide();
  };

  return (
    <Modal
      {...antdModalV5(modal)}
      open={modal.visible}
      onClose={handleClose}
      closeAfterTransition
      {...props}
      className={cn(styles.modal, className)}
    >
      <>
        <img src={src} alt="entity" />
      </>
    </Modal>
  );
};

export default NiceModal.create(ImageShowModal);
